var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildLegend, buildTooltip, buildVisualMap, mergeHeatmapSettings, } from "./shared";
function getHeatmapStats(values) {
    var min;
    var max;
    values.forEach(function (row) {
        row.forEach(function (value) {
            if (value === null || value === undefined) {
                return;
            }
            if (min === undefined || value < min) {
                min = value;
            }
            if (max === undefined || value > max) {
                max = value;
            }
        });
    });
    return { min: min, max: max };
}
var heatmapChartAdapter = {
    type: "heatmap",
    buildOption: function (ctx) {
        var _a, _b, _c, _d;
        var data = ctx.data;
        var mergedSettings = mergeHeatmapSettings(ctx.settings);
        var _e = getHeatmapStats(data.values), min = _e.min, max = _e.max;
        var legend = buildLegend(data.legend, mergedSettings.legend);
        var tooltip = buildTooltip(data.tooltip, {
            trigger: (_b = (_a = mergedSettings.tooltip) === null || _a === void 0 ? void 0 : _a.trigger) !== null && _b !== void 0 ? _b : "item",
            enable: (_c = mergedSettings.tooltip) === null || _c === void 0 ? void 0 : _c.enable,
            formatter: (_d = mergedSettings.tooltip) === null || _d === void 0 ? void 0 : _d.formatter,
        });
        var visualMap = buildVisualMap(data.visualMap, mergedSettings.visualMap, { min: min, max: max });
        var seriesData = [];
        data.values.forEach(function (row, rowIndex) {
            row.forEach(function (value, columnIndex) {
                seriesData.push([columnIndex, rowIndex, value !== null && value !== void 0 ? value : null]);
            });
        });
        var series = [
            {
                type: "heatmap",
                data: seriesData,
                itemStyle: mergedSettings.cellBorderColor
                    ? { borderColor: mergedSettings.cellBorderColor }
                    : undefined,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: "rgba(0, 0, 0, 0.4)",
                    },
                },
            },
        ];
        var option = {
            xAxis: {
                type: "category",
                data: data.xCategories,
                splitArea: { show: true },
            },
            yAxis: {
                type: "category",
                data: data.yCategories,
                splitArea: { show: true },
            },
            legend: legend,
            tooltip: tooltip,
            series: series,
        };
        if (visualMap) {
            option.visualMap = __assign({ type: "continuous" }, visualMap);
        }
        return option;
    },
    getDefaultSettings: function () { return ({
        legend: { show: false },
        tooltip: { enable: true, trigger: "item" },
        visualMap: { show: true, calculable: true },
        cellBorderColor: "#ffffff",
    }); },
};
export default heatmapChartAdapter;
